export default __webpack_public_path__ + "static/media/albert_search_teacher.7b2c7608.svg";